import React, { useState } from "react";
import { MDBModal, MDBModalBody } from "mdbreact";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { CardElement } from "@stripe/react-stripe-js";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import CloseIcon from "@material-ui/icons/Close";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import config from "../../config";
import { useTranslation } from "react-i18next";
import styles from "./PaymentModal.module.scss";

const stripePromise = loadStripe(`${config.stripe_key}`, {
  stripeAccount: `${config.stripe_account}`,
});

const stripePromiseFrance = loadStripe(`${config.stripe_key_france}`, {
  stripeAccount: `${config.stripe_account_france}`,
});
const ModalComponent = ({ isOpen, toggle, paymentIntent, countryCode, onSuccess, text }) => {
  const { t } = useTranslation();
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const handleSubmit = async () => {
    if (!stripe || !elements) {
      return;
    }

    const result = await stripe.confirmCardPayment(`${paymentIntent}`, {
      payment_method: {
        card: elements.getElement(CardElement),
        billing_details: {
          name: "Daycare 1",
        },
      },
    });

    if (result.error) {
      console.log(result.error.message);
      setError(result.error.message);
    } else {
      if (result.paymentIntent.status === "succeeded") {
        console.log("Payment succeeded!");
        onSuccess();
        toggle();
      }
    }
  };

  return (
    <MDBModal size="md" isOpen={isOpen} toggle={toggle} centered disableBackdrop className={styles.paymentModal}>
      <MDBModalBody className={styles.paymentBody}>
        <button type="button" className={styles.closeButton} onClick={toggle} aria-label={t("Close")}>
          <CloseIcon />
        </button>
        <div className={styles.modalIcon}>
          <CreditCardIcon />
        </div>
        <div className={styles.modalHeader}>
          <span>{t("Payroll")}</span>
          <h3>{text}</h3>
          <p>{t("Enter card details to complete the selected staff salary payment.")}</p>
        </div>
        <div className={styles.cardElementWrap}>
          <CardElement
            options={{
              style: {
                base: {
                  fontSize: "16px",
                  color: "#101828",
                  fontFamily: "inherit",
                  "::placeholder": {
                    color: "#98a2b3",
                  },
                },
                invalid: {
                  color: "#b42318",
                },
              },
            }}
          />
        </div>
        <div className={styles.modalActions}>
          <button type="button" className={styles.secondaryButton} onClick={toggle}>
            {t("Cancel")}
          </button>
          <button type="button" className={styles.primaryButton} onClick={() => handleSubmit()} disabled={!stripe}>
            {text}
          </button>
        </div>
        {error && (
          <div className={styles.errorMessage}>{error}</div>
        )}
      </MDBModalBody>
    </MDBModal>
  );
};
const CardStripe = ({ isOpen, toggle, paymentIntent, countryCode, onSuccess }) => {
  const {t} = useTranslation();
  return (
    <Elements stripe={countryCode == "FR" ? stripePromiseFrance : stripePromise}>
      <ModalComponent
        isOpen={isOpen}
        toggle={toggle}
        countryCode={countryCode}
        paymentIntent={paymentIntent}
        onSuccess={onSuccess}
        text={t("Make Payment")}
      />
    </Elements>
  );
};

export default CardStripe;
